import React, { useCallback, useState } from 'react';
import { usePositionContext } from '@/shared/context/PositionContext.tsx';
import { ProductTemplateSelection } from '@/shared/components/PresetSelection/ProductTemplateSelection.tsx';
import { ManualPositionProductSelection } from '@/modules/position/components/ManualPositionProductSelection.tsx';
import { ProductTemplateSelectedOption } from '@/shared/components/PresetSelection/types.ts';
import { UnifiedAutomaticPositionProductSelection } from '@/modules/position/components/UnifiedAutomaticPositionProductSelection.tsx';

type ProcessingTypeSelectionProps = {
    onContinue: () => void;
};

export const ProcessingTypeSelection = ({ onContinue }: ProcessingTypeSelectionProps) => {
    const { processingType, contextData, setProcessingType } = usePositionContext();

    const formData = contextData.getFormData();
    const businessCase = contextData.getBusinessCase();

    const [needsTemplateSelection, setNeedsTemplateSelection] = useState<boolean>(
        !businessCase && !formData.productType
    );

    const handleTemplateSelect = useCallback(
        ({ productType, isStandalone, pricingStrategy, formPreset }: ProductTemplateSelectedOption) => {
            if (pricingStrategy) {
                contextData.setBusinessCase({ productType, pricingStrategy, isStandalone }, formPreset);
            } else {
                contextData.setFormData({ productType, isStandalone, ...formPreset });
            }
            setNeedsTemplateSelection(false);
        },
        [contextData]
    );

    const handleClearBusinessCase = useCallback(() => {
        contextData.setBusinessCase(undefined);
        setNeedsTemplateSelection(true);
    }, [contextData]);

    if (needsTemplateSelection) {
        return (
            <ProductTemplateSelection
                processingType={processingType}
                onChangeProcessingType={setProcessingType}
                onSelect={handleTemplateSelect}
            />
        );
    }

    if (processingType === 'AUTOMATIC') {
        return (
            <UnifiedAutomaticPositionProductSelection
                onContinue={onContinue}
                onClearSelection={handleClearBusinessCase}
            />
        );
    } else {
        return <ManualPositionProductSelection onContinue={onContinue} onClearSelection={handleClearBusinessCase} />;
    }
};
